import { CommonModule, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import { Client, GuidDictionaryItem } from '../../../../../../../api/api-reference';
import { FilterPanelComponent } from '../../filter-panel.component';

export interface RawAlarmsFilterOutput {
  selectedAssetTypes: string[];
}

@Component({
  selector: 'app-raw-alarms-filter',
  standalone: true,
  imports: [CommonModule, NgFor, TranslateModule, FilterPanelComponent],
  templateUrl: './raw-alarms-filter.component.html',
  styleUrl: './raw-alarms-filter.component.scss',
})
export class RawAlarmsFilterComponent implements OnInit {
  @Input() numberOfResults: number = 0;
  @Input() selectedAssetTypes: string[] = [];

  @Output() applied = new EventEmitter<RawAlarmsFilterOutput>();

  assetTypes: GuidDictionaryItem[] = [];
  draftAssetTypes: string[] = [];

  get activeFilterCount(): number {
    return this.selectedAssetTypes.length;
  }

  constructor(private client: Client, private toastr: ToastrService) {}

  ngOnInit(): void {
    this.reset();
    this.client.getAllAssetTypesForOptions(undefined).subscribe({
      next: (res) => (this.assetTypes = res ?? []),
      error: (err) => this.toastr.error(err),
    });
  }

  isIn<T>(list: T[], item: T): boolean {
    return list.includes(item);
  }

  toggleGuid(list: string[], item: GuidDictionaryItem): string[] {
    const val = item.value!;
    return list.includes(val) ? list.filter((v) => v !== val) : [...list, val];
  }

  onApply(): void {
    this.applied.emit({ selectedAssetTypes: this.draftAssetTypes });
  }

  onCancel(): void {
    this.reset();
  }

  private reset(): void {
    this.draftAssetTypes = [...this.selectedAssetTypes];
  }
}
